module.exports = __webpack_public_path__ + "img/triangles-loader.c3717255.svg";